// extracted by mini-css-extract-plugin
export default {"container":"Dots_container__gqqvw","dotsContainer":"Dots_dotsContainer__+lDpJ","value":"Dots_value__iOT+z"};